import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8eab6ca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small-text" }, "Authors should be entered in the same fashion as in bibtex", -1))

import Input from '@/components/UI/InputComponent.vue'
import Button from '@/components/UI/ButtonComponent.vue'
import { ref, inject, reactive, onMounted } from 'vue'
import store from '@/store'
import ToggleComponent from '@/components/UI/ToggleComponent.vue'


export default {
  __name: 'PaperDescription',
  props: 'data',
  emits: ['next'],
  setup(__props, { emit: emits }) {

console.log(store)

const axios = inject('axios')




const paper = reactive({
  title: '',
  shortTitle: '',
  citationKey: '',
  doi: '',
  authors: '',
  date: '',
  privateUrl: '',
  modoApproved: false
})
const papers = ref([])
let paperSelected = reactive({})
const reload = ref(0)

function next () {
  if (paperSelected.citationKey === paper.citationKey) {
    paper.citationKey = paper.authors.split(',')[0] + paper.date
    paper.shortTitle = paper.title.includes(':') ? paper.title.split(':')[0] : paper.title.slice(0, 20)
    paper.authorApproved = false
  }
  update()
  localStorage.setItem('paperDescription', JSON.stringify({ citationKey: paperSelected.citationKey }))
  emits('next', { citationKey: paperSelected.citationKey })
}

function update () {
  axios.post(`/api/paper/${paperSelected.citationKey}`, { content: paperSelected })
}

onMounted(() => {
  axios('/api/papers').then((_papers) => {
    paperSelected = paper
    papers.value = _papers.data
    if (localStorage.getItem('paperDescription')) {
      const paperToSelect = JSON.parse(localStorage.getItem('paperDescription'))
      const p = papers.value.filter(x => x.citationKey === paperToSelect.citationKey)
      console.log(p, paperToSelect)
      if (p.length) paperSelected = p[0]
    }
  })
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("select", {
      name: "communities-select",
      id: "communities-select",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(paperSelected) ? (paperSelected).value = $event : paperSelected = $event)),
      onChange: _cache[1] || (_cache[1] = $event => (reload.value++))
    }, [
      _createElementVNode("option", { value: paper }, "New Paper", 8, _hoisted_1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(papers.value.filter(p => _unref(store).isModo || !p.modoApproved), (paper) => {
        return (_openBlock(), _createElementBlock("option", {
          key: paper.citationKey,
          value: paper
        }, [
          _createTextVNode(_toDisplayString(paper.citationKey) + ": " + _toDisplayString(paper.shortTitle) + " ", 1),
          (_unref(store).isModo && !paper.modoApproved)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("--- A CHECK")
              ], 64))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      }), 128))
    ], 544), [
      [_vModelSelect, _unref(paperSelected)]
    ]),
    (_openBlock(), _createElementBlock("span", {
      key: reload.value,
      class: "form"
    }, [
      _createVNode(Input, {
        class: "wide",
        placeholder: "Title",
        modelValue: _unref(paperSelected).title,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_unref(paperSelected).title) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", null, [
        _createVNode(Input, {
          class: "wide",
          placeholder: "Authors",
          modelValue: _unref(paperSelected).authors,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_unref(paperSelected).authors) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_3
      ]),
      _createVNode(Input, {
        class: "wide",
        placeholder: "Year",
        modelValue: _unref(paperSelected).date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_unref(paperSelected).date) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(Input, {
        class: "wide",
        placeholder: "DOI",
        modelValue: _unref(paperSelected).doi,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_unref(paperSelected).doi) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(Input, {
        class: "wide",
        placeholder: "Gricad url (not mandatory)",
        modelValue: _unref(paperSelected).privateUrl,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_unref(paperSelected).privateUrl) = $event))
      }, null, 8, ["modelValue"]),
      (_unref(store).isModo)
        ? (_openBlock(), _createBlock(ToggleComponent, {
            key: 0,
            modelValue: _unref(paperSelected).modoApproved,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_unref(paperSelected).modoApproved) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])),
    (_unref(paperSelected).citationKey !== paper.citationKey)
      ? (_openBlock(), _createBlock(Button, {
          key: 0,
          onClick: update
        }, {
          default: _withCtx(() => [
            _createTextVNode("Update")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(Button, { onClick: next }, {
      default: _withCtx(() => [
        _createTextVNode("Next")
      ]),
      _: 1
    })
  ]))
}
}

}